// BNB Smart Chain (BSC) constants shared by OpinionLabs and Predict.fun
export const BSC_CHAIN_ID = 56
export const BSC_RPC_URL = 'https://bsc-dataseed.binance.org'

// Gnosis Safe infrastructure on BSC
export const SAFE_FACTORY_ADDRESS = '0xaacFeEa03eb1561C4e67d661e40682Bd20E3541b'
export const MULTISEND_ADDRESS = '0x998739BFdAAdde7C933B942a68053933098f9EDa'
export const SAFE_SINGLETON_ADDRESS = '0xd9Db270c1B5E3Bd161E8c8503c55cEABeE709552'
export const FALLBACK_HANDLER_ADDRESS = '0xf48f2B2d2a534e402487b3ee7C18c33Aec0Fe5e4'

// Predict.fun CTF Exchange contracts on BSC (from @predictdotfun/sdk)
export const PREDICTFUN_CTF_EXCHANGE = '0x8BC070BEdAB741406F4B1Eb65A72bee27894B689'
export const PREDICTFUN_NEG_RISK_CTF_EXCHANGE = '0x365fb81bd4A24D6303cd2F19c349dE6894D8d58A'
export const PREDICTFUN_YIELD_CTF_EXCHANGE = '0x6bEb5a40C032AFc305961162d8204CDA16DECFa5'
export const PREDICTFUN_YIELD_NEG_RISK_CTF_EXCHANGE = '0x8A289d458f5a134bA40015085A8F50Ffb681B41d'
export const PREDICTFUN_NEG_RISK_ADAPTER = '0xc3Cf7c252f65E0d8D88537dF96569AE94a7F1A6E'
export const PREDICTFUN_YIELD_NEG_RISK_ADAPTER = '0x41dCe1A4B8FB5e6327701750aF6231B7CD0B2A40'
export const PREDICTFUN_CONDITIONAL_TOKENS = '0x22DA1810B194ca018378464a58f6Ac2B10C9d244'
export const PREDICTFUN_YIELD_CONDITIONAL_TOKENS = '0x9400F8Ad57e9e0F352345935d6D3175975eb1d9F'
export const PREDICTFUN_YIELD_NEG_RISK_CONDITIONAL_TOKENS =
	'0xF64b0b318AAf83BD9071110af24D24445719A07F'
